import {
  WindowActionTypes,
  WindowActions
} from './window.actions';

export interface WindowState {
  title?: string;
  icon?: string;
  width?: string;
  height?: string;
  x?: string;
  y?: string;
  resizable: boolean;
  draggable: boolean;
  fullscreen: boolean;
  minimized: boolean;
}

export const WINDOW_INIT_STATE: WindowState = {
  resizable: true,
  draggable: true,
  minimized: false,
  fullscreen: false,
};

export interface WindowsState {
  [ windowId: string ]: WindowState
}

export function windowReducer(state: WindowState = WINDOW_INIT_STATE, action: WindowActions): WindowState {
  switch (action.type) {
    case WindowActionTypes.MinimizeWindow:
      return { ...state, minimized: true };
    case WindowActionTypes.ReopenWindow:
      return { ...state, minimized: false };
    case WindowActionTypes.FullScreenWindow:
      return { ...state, fullscreen: true };
    case WindowActionTypes.SetWindowTitle:
      return { ...state, title: action.title };
    case WindowActionTypes.SetWindowIcon:
      return { ...state, icon: action.icon };
    case WindowActionTypes.SetWindowHeight:
      return { ...state, height: action.height };
    case WindowActionTypes.SetWindowWidth:
      return { ...state, width: action.width };
    case WindowActionTypes.SetWindowPositiion:
      return { ...state, x: action.x, y: action.y };

    default:
      return state;

  }
}

export function windowsReducer(state: WindowsState = {}, action: WindowActions): WindowsState {

  if (action.windowId) {

    switch (action.type) {

      case WindowActionTypes.WindowOpend:
        return {
          ...state,
          [ action.windowId ]: {
            ...WINDOW_INIT_STATE,
            width:     action.config.width,
            height:    action.config.height,
            title:     action.config.title,
            icon:      action.config.icon,
            resizable: action.config.hasOwnProperty('resizeable') ? action.config.resizeable : WINDOW_INIT_STATE.resizable,
            draggable: action.config.hasOwnProperty('draggable') ? action.config.draggable : WINDOW_INIT_STATE.draggable
          }
        };

      case WindowActionTypes.CloseWindow:
        const clone = { ...state };
        delete clone[ action.windowId ];
        return clone;

      default:
        return { ...state, [ action.windowId ]: windowReducer(state[ action.windowId ], action) };

    }

  }

  return state;

}
